/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  height: 40px;
  min-width: 135px;
  white-space: nowrap;
  color: ${Palette.PrimaryGray._700};
  padding: 0px 16px;
  border-radius: 4px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  user-select: none;
  text-transform: capitalize;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};

  &:last-of-type {
    min-width: 160px;
  }

  ${({ isSelected }) =>
    isSelected
      ? css`
          color: ${Palette.PrimaryGray._700};
          border: 1px solid ${Palette.Primary._200};
          font-weight: 500;
          background-color: ${Palette.Primary._000};
        `
      : css`
          color: ${Palette.PrimaryGray._400};
          border: 1px solid ${Palette.PrimaryGray._200};
          font-weight: 400;
          background-color: white;
        `}
`;

export const Box = styled.div`
  font-size: 14px;
  font-weight: 500;
  border-right: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  height: ${({ height }) => `${height}px`};
  color: ${Palette.PrimaryGray._500};
  display: flex;
  align-items: center;
  padding-left: 16px;
  gap: 8px;

  &:last-child {
    padding-right: 16px;
  }

  & svg {
    margin-top: 2px;
  }
`;

export const Option = styled.div`
  padding: 10px 8px;
  cursor: pointer;
  text-transform: capitalize;
  color: ${({ isSelected }) =>
    isSelected ? `${Palette.Primary._500}` : `${Palette.PrimaryGray._500}`};
  background: ${({ isSelected }) => (isSelected ? `${Palette.PrimaryGray._100}` : 'transparent')};
  border: ${({ isSelected }) => (isSelected ? `1px solid ${Palette.Primary._300}` : 'unset')};
  border-radius: 4px;

  &:hover {
    color: ${Palette.Primary._500};
    background: ${Palette.PrimaryGray._100};
  }
`;

export const DefaultText = styled.span`
  color: ${Palette.PrimaryGray._400};
  font-weight: 400;
  text-transform: none;
`;

export const ArrowIcon = styled.div`
  display: flex;
  padding: 4px;
  cursor: pointer;
  fill: ${Palette.PrimaryGray._500};
  transition: transform 0.2s linear;

  ${({ direction }) => {
    if (direction === 'ascending')
      return css`
        fill: ${Palette.Primary._500};
        transform: rotate(180deg);
      `;
    if (direction === 'descending')
      return css`
        fill: ${Palette.Primary._500};
      `;
  }}

  svg {
    width: 8px;
  }
`;
